import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Switch } from "@air/primitive-switch";
export const SharePrivateContentPermissionToggle = (param)=>{
    let { checked, disabled, id, isLoading, label, onCheckedChange, children } = param;
    return /*#__PURE__*/ _jsxs("div", {
        className: "flex w-full items-center justify-between",
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: "mt-1 flex items-center",
                children: [
                    /*#__PURE__*/ _jsx("label", {
                        className: "mr-2 text-14 text-grey-12",
                        children: label
                    }),
                    children
                ]
            }),
            /*#__PURE__*/ _jsx(Switch, {
                checked: checked,
                "data-id": id,
                disabled: disabled,
                id: id,
                isLoading: isLoading,
                onCheckedChange: onCheckedChange
            })
        ]
    });
};
